"use client"

import React, { Component } from "react"
import PropTypes from "prop-types"
import "./dropdownButtons.scss"

class Dropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showOptions: false,
    }
    this.dropdownId = `dropdown-menu-${Math.random().toString(36).substr(2, 9)}`
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside)
    document.addEventListener("keydown", this.handleKeyDown)
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside)
    document.removeEventListener("keydown", this.handleKeyDown)
  }

  setDropdownRef = (node) => {
    this.dropdownRef = node
  }

  handleClickOutside = (event) => {
    if (this.dropdownRef && !this.dropdownRef.contains(event.target)) {
      this.setState({ showOptions: false })
    }
  }

  toggleOptions = (e) => {
    e.stopPropagation()
    this.setState((prevState) => ({
      showOptions: !prevState.showOptions,
    }))
  }

  handleKeyDown = (event) => {
    if (event.key === "Escape" && this.state.showOptions) {
      this.setState({ showOptions: false })
    }

    if (!this.state.showOptions || !this.dropdownRef) return

    const menuItems = this.dropdownRef.querySelectorAll('[role="menuitem"]')
    if (!menuItems.length) return

    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault()

      const currentIndex = Array.from(menuItems).findIndex((item) => item === document.activeElement)

      let nextIndex
      if (event.key === "ArrowDown") {
        nextIndex = currentIndex < menuItems.length - 1 ? currentIndex + 1 : 0
      } else {
        nextIndex = currentIndex > 0 ? currentIndex - 1 : menuItems.length - 1
      }

      menuItems[nextIndex].focus()
    }
  }

  render() {
    const { fromProfile } = this.props
    const { showOptions } = this.state

    return (
      <div className="dropdown-button-container" ref={this.setDropdownRef}>
        <button
          className="button"
          id={`${this.dropdownId}-button`}
          onClick={(e) => this.toggleOptions(e)}
          aria-haspopup="true"
          aria-expanded={showOptions}
          aria-controls={this.dropdownId}
        >
          {this.props.buttonContent}
          <span className="sr-only">Toggle menu</span>
        </button>

        {showOptions && (
          <div
            className={`dropdown${fromProfile ? "_profile" : ""}`}
            role="menu"
            id={this.dropdownId}
            aria-labelledby={`${this.dropdownId}-button`}
          >
            {React.Children.map(this.props.children, (child, index) => {
              if (React.isValidElement(child) && child.props.role === "menuitem") {
                return React.cloneElement(child, {
                  tabIndex: 0,
                  onKeyDown: (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault()
                      e.target.click()
                    }
                  },
                })
              }
              return (
                <div
                  role="menuitem"
                  tabIndex={0}
                  key={index}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault()
                      if (child.props && typeof child.props.onClick === "function") {
                        child.props.onClick(e)
                      }
                    }
                  }}
                >
                  {child}
                </div>
              )
            })}
          </div>
        )}
      </div>
    )
  }
}

Dropdown.propTypes = {
  buttonContent: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  fromProfile: PropTypes.bool,
}

export default Dropdown
